import { render, staticRenderFns } from "./security_roll_call_history.vue?vue&type=template&id=54ff286e&scoped=true"
import script from "./security_roll_call_history.vue?vue&type=script&lang=js"
export * from "./security_roll_call_history.vue?vue&type=script&lang=js"
import style0 from "./security_roll_call_history.vue?vue&type=style&index=0&id=54ff286e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ff286e",
  null
  
)

export default component.exports